import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { Footer } from '../components/Footer';
import QRCodeModal from '../components/QRCodeModal';
import { useDarkMode } from '../hooks';
import { AppRoutes } from './AppRoutes';
import navigationData from '../data/navigation.json';
import footerData from '../data/footer.json';

/**
 * Routes Component
 * Handles route-level layout with conditional Nav/Footer rendering
 * Hides Nav/Footer/Dark toggle on /franchise-selection page
 */
export const Routes = () => {
  const location = useLocation();
  useDarkMode();
  const [isQRModalOpen, setIsQRModalOpen] = useState(false);
  
  // Hide layout components on franchise selection page
  const showLayout = location.pathname !== '/franchise-selection';

  // Handle Book Appointment click from Navigation
  const handleBookAppointmentClick = () => {
    setIsQRModalOpen(true);
  };

  return (
    <>
      {/* QR Code Modal - Global */}
      <QRCodeModal 
        isOpen={isQRModalOpen} 
        onClose={() => setIsQRModalOpen(false)} 
      />

      {/* Dark Mode Toggle - Hidden on franchise selection */}
      {/* {showLayout && (
        <motion.button
          onClick={toggleTheme}
          className="fixed bottom-8 right-8 z-50 text-primary hover:text-primary/80 transition-all duration-300 focus-visible:ring-2 focus-visible:ring-primary/50 rounded-full"
          aria-label="Toggle dark mode"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 1 }}
          whileHover={{ scale: 1.08, rotate: 180 }}
          whileTap={{ scale: 0.9 }}
        >
          <span className="material-symbols-outlined text-[clamp(1.8rem,5vw,2.5rem)]">
            {isDarkMode ? 'light_mode' : 'dark_mode'}
          </span>
        </motion.button>
      )} */}

      {/* Navigation - Hidden on franchise selection */}
      {showLayout && (
        <Navigation 
          data={navigationData as any} 
          onMenuItemClick={(item) => {
            // Only handle Book Appointment, let Navigation handle everything else
            if (item.label === 'Book Appointment') {
              handleBookAppointmentClick();
              return true; // Signal that we handled it
            }
            // Return false to let Navigation's default behavior run
            return false;
          }}
        />
      )}
      
      {/* Routes */}
      <AppRoutes />
      
      {/* Footer - Hidden on franchise selection */}
      {showLayout && <Footer data={footerData as any} />}
    </>
  );
};
